import React from 'react'

const Contact = () => {
  return (
    <section>
      <div className='container'>
        <h2>Contact Us</h2>
        <p>
          For all inquiries, Please Contact Wyarej Ali at{' '}
          <a href='mailto:wyarejali@gmail.com'>wyarejali@gmail.com</a>
        </p>
      </div>
    </section>
  )
}

export default Contact
